import { createRoot } from 'react-dom/client';
import App from './App';

import '@mesa-labs/ui/reset.css';
import '@radix-ui/themes/styles.css';
import './styles/global.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
